// TODO: Use this service instead of services/matter/matter.service.ts once MatterCSharp feature is fully rolled-out
import { Injectable } from '@angular/core';
import {
	ActingForType,
	Matter,
	MatterBusinessUser,
	MatterFileType,
} from '@models/matter';
import 'firebase/firestore';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Api } from '../api.service';
import { catchError } from 'rxjs/operators';
import LogRocket from 'logrocket';
import { BusinessUserRole } from '@models/businesses';

export interface BaseCreateMatterModel {
	name: string;
	number: string;
	createdBy: { name: string; id: string };
	clerkAssigned: { name: string; id: string };
	lawyerAssigned: { name: string; id: string };
	fileType: MatterFileType;
	referral?: string;
	officeId: string;
	actingFor?: ActingForType;
}

export interface TransferActiveMatterOwnershipModel {
	deactivatedUser: MatterBusinessUser;
	transferToUser: MatterBusinessUser;
	role: BusinessUserRole;
}
export interface MatterBankingReport {
	closingDate: string;
	fileType: MatterFileType;
	number: string;
	amountReceived: string;
	lender: string;
	clientLastNames: string;
	clerkInitials: string;
	lawyerInitials: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterService extends Api {
	constructor(private http: HttpClient) {
		super(http);
	}

	private basePath = `${environment.api.baseUrl}/closer/matter`;

	Create(
		matter: BaseCreateMatterModel,
		id: string,
	): Observable<Partial<Matter>> {
		const url = `${this.basePath}/${id}`;

		return this.http.post<Partial<Matter>>(
			url,
			{ ...matter, matterSource: 'closer' },
			{ responseType: 'text' as 'json' },
		);
	}

	TransferActiveMatterOwnership(
		model: TransferActiveMatterOwnershipModel,
	): Observable<object> {
		const url = `${this.basePath}/transfer-ownership`;

		return this.http.post(url, model, { responseType: 'text' as 'json' }).pipe(
			catchError((error) => {
				LogRocket.error('Error transferring matter ownership', {
					error,
					model,
				});
				return throwError(error);
			}),
		);
	}

	GetUserAssignedActiveMatterCount(
		userId: string,
		role: BusinessUserRole,
	): Observable<number> {
		const url = `${this.basePath}/users/${userId}/assigned-matter-count/${role}`;
		return this.http.get<number>(url, { responseType: 'text' as 'json' }).pipe(
			catchError((error) => {
				LogRocket.error('Error getting user assigned matters count', {
					error,
					userId,
				});
				return throwError(error);
			}),
		);
	}

	GetBankingReport(
		startDate: Date | string,
		endDade: Date | string,
	): Observable<MatterBankingReport[]> {
		return this.http
			.get<
				MatterBankingReport[]
			>(`${this.basePath}/banking-report?startDate=${startDate}&endDate=${endDade}`)
			.pipe(
				catchError((error) => {
					LogRocket.error('Error to generate banking report', {
						error,
					});
					return throwError(error);
				}),
			);
	}
}
